module.exports = __webpack_public_path__ + "img/recommendations-exercise-tip.5761edcb.svg";